import React from 'react'
import PropTypes from 'prop-types'
import { Information24, WarningAlt24  } from '@carbon/icons-react' 

export default function NotificationBox( props ) {

    const getImage = ( style ) => {
        switch ( style ) {
            case 'info':
                return <Information24 className = 'c-carbon-info-icon-gray'/>
            case 'mid-alert':
                return <WarningAlt24 className = 'c-carbon-warning-icon-orange'/>
            case 'high-alert':
                return <WarningAlt24 className = 'c-carbon-warning-icon-red'/>
            default:
              return <WarningAlt24 className = 'c-carbon-warning-icon-orange'/>
        }
    }

    const image = getImage( props.style )
    
    return (
        <>
            { props.visible &&
            <div className= "c-form-notification-box">
                <div className={ `c-page-notification ${ props.style }` } role="alert" >
                    <div className={ `c-page-notification__icon ${ props.style }` }>
                        { image }
                    </div>
                    <div className="c-page-notification__content" dangerouslySetInnerHTML={ { __html: props.markup } }/>
                </div>
            </div>
            }
        </>
    )
}

NotificationBox.propTypes = {
    visible: PropTypes.bool,
    style: PropTypes.string,
    markup: PropTypes.string,
}
